import { type AxiosError } from 'axios';

export enum CommonErrors {
    notFound = 'notFound',
    permissionDenied = 'permissionDenied',
}

export type HandleExceptionOptions = {
    showDefaultError?: boolean;
    icon?: 'warning' | 'error';
    defaultMessage?: string;
    closeOnClickOutside?: boolean;
    title?: string;
    ignoreReport?: boolean;
};

const defaultOptions: HandleExceptionOptions = {
    showDefaultError: true,
    icon: 'error',
    closeOnClickOutside: true,
};

const defaultError = {
    title: 'توجه',
    text: 'مشکلی در ارتباط با سرور رخ داد. لطفاً مجددا تلاش کنید.',
    ok: 'باشه',
};

const commonErrors = {
    notFound: 'موردی یافت نشد.',
    permissionDenied: 'عدم دسترسی.',
};
const handleException = async (
    error: any,
    options?: HandleExceptionOptions
): Promise<boolean> => {
    const {
        showDefaultError,
        icon,
        defaultMessage,
        closeOnClickOutside,
        title = defaultError.title,
        ignoreReport,
    } = {
        ...defaultOptions,
        ...options,
    };
    const urlMatcher = (input: string) =>
        input.replaceAll(
            /(?:(?:https?:\/\/)?(?:www\.)?)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*/g,
            matched =>
                `<a href="${matched}" target="_blank" rel="nofollow">${matched}</a>`
        );
    const showError = async (msg?: string) => {
        await swal({
            title,
            icon,
            html: urlMatcher(msg || defaultMessage || defaultError.text),
            confirmButtonText: defaultError.ok,
            allowOutsideClick: closeOnClickOutside,
            allowEscapeKey: closeOnClickOutside,
        });
    };
    if (!ignoreReport) {
        reportException(error);
    }
    if (error.response?.data) {
        // server errors
        const err = error as AxiosError;
        const data = err.response!.data as any;
        const errorMessage =
            typeof data === 'string'
                ? data
                : data.error || data.Error || data.message || data.Message;
        await showError(errorMessage);
        return !!errorMessage;
    } else if (error in CommonErrors) {
        const err = error as CommonErrors;
        await swal({
            title: commonErrors[CommonErrors[err]],
            icon,
            text: '',
            confirmButtonText: defaultError.ok,
            allowOutsideClick: closeOnClickOutside,
            allowEscapeKey: closeOnClickOutside,
        });
        return true;
    } else if (error.message) {
        await swal({
            title,
            icon,
            html: urlMatcher(error.message),
            confirmButtonText: defaultError.ok,
            allowOutsideClick: closeOnClickOutside,
            allowEscapeKey: closeOnClickOutside,
        });
        return true;
    } else if (showDefaultError) {
        await showError();
        return true;
    }
    return false;
};

export default handleException;
